import PolicyRouteConstants from 'Agent/Policies/PolicyRouteConstants';

export default {
  CLAIMS: (policyNumber: string, source: string) => `${PolicyRouteConstants.POLICIES}/${policyNumber}/claims?source=${source}`,
};
